/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrentUrl = getCurrentUrl;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getCurrentUrl(state) {
    return state.entities.general.credentials.url;
}



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/selectors/entities/general.js
// module id = 1231
// module chunks = 60